/**
 * <pre>
 * Voting config.
 *
 * Summary of responsibilities:
 *
 *  - defines any commonly used config values specific to Voting.
 * </pre>
 *
 * @author Tim Loram
 *
 * @memberof module:Voting
 * @namespace
 *
 * @type {Object}
 */
const Config = {

	// The key to use when creating the root store using combineReducers.
	stateKey: 'voting',

	// API endpoints.
	api: {		
		cta: '/display/page/votecta'
	}
};

export default Config;
